<div class="main-wrap" *ngIf="userService.hasAnyRole(['admin', 'editor'])">
  <p-toast></p-toast>
  <p-toast [style]="{'width': '400px'}" position="center" key="dialog" (onClose)="onReject()" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
      <div style="text-align: center">
          <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
          <h3>{{message.summary}}</h3>
          <p>{{message.detail}}</p>
      </div>
      <div class="ui-g ui-fluid">
          <div class="ui-g-6">
              <button type="button" pButton (click)="onConfirm()" label="Yes, just do it." class="p-button-success"></button>
          </div>
          <div class="ui-g-6">
              <button type="button" pButton (click)="onReject()" label="No, I cancel." class="p-button-secondary"></button>
          </div>
      </div>
  </ng-template>
  </p-toast>
  <div class="forms-wrap" *ngIf="bookingForm">
    <div *ngIf="hasError">
      Unknown error, please try again later.
    </div>
    <div *ngIf="success" class="success-box">
      <p>
        Booking is created successfully.
      </p>
      <p>URL to send: </p>
      <a>
        {{formPath}}
      </a>
      <button pButton type="button" label="Copy URL to clipboard" (click)="copyUrl()" id="copy-button"></button>
    </div>
    <p id="title">
      Add new student for Bruges / VND.
    </p>
    <p *ngIf="sendingRequest">
      Creating booking...
    </p>
    <div [formGroup]="bookingForm">
      <table>
        <tr>
          <td>
            School
          </td>
          <td>
            <p-dropdown [options]="schools" optionLabel="name" formControlName="school" placeholder="Select a School"></p-dropdown>
          </td>
        </tr>
        <tr>
          <td>
            Last name
          </td>
          <td>
            <input pInputText type="text" formControlName="lastName">
          </td>
        </tr>
        <tr>
          <td>
            First name
          </td>
          <td>
            <input pInputText type="text" formControlName="firstName">
          </td>
        </tr>
        <tr>
          <td>
            Start date:
          </td>
          <td>
            <p-calendar formControlName="startDate" [monthNavigator]="true" [yearNavigator]="false" dateFormat="dd/mm/yy"
            [showOtherMonths]="false" (onSelect)="updateEndMonth()"></p-calendar>
          </td>
        </tr>
        <tr>
          <td>
            End date:
          </td>
          <td>
            <p-calendar [defaultDate]="defaultEndDate" formControlName="endDate" [monthNavigator]="true" [yearNavigator]="false" dateFormat="dd/mm/yy"
            [showOtherMonths]="false"></p-calendar>
          </td>
        </tr>
        <tr>
          <td>
            Select language of form
          </td>
          <td>
            <p-dropdown [options]="languages" formControlName="studentLanguage" optionLabel="name"></p-dropdown>
          </td>
        </tr>
        <tr>
          <td>
            Select sales agent:
          </td>
          <td>
            <p-dropdown placeholder="Select an agent" [options]="agents" formControlName="agent" optionLabel="name"></p-dropdown>
          </td>
        </tr>
      </table>
      <br>
      <button pButton type="button" label="Submit" (click)="createBooking()"></button>
    </div>
  </div>
</div>